
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/semilleros",
      function () {
        return require("private-next-pages/semilleros/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/semilleros"])
      });
    }
  